const imageStyles = (tokens) => ({
    variants: {
        focusable: {
            cursor: 'pointer',
            _focus: {
                outline: 'none',
                boxShadow: 'none',
            },
            _focusVisible: {
                boxShadow: 'none',
                outline: `1px solid ${tokens.BorderFocus}`,
                outlineOffset: tokens.Spacing01,
            },
        },
    },
});
export default imageStyles;
